export default __webpack_public_path__ + "static/media/btn_motioncomics_active.8db8ca24.png";